/* import __COLOCATED_TEMPLATE__ from './mobile-category-topic.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import { showEntrance } from "discourse/components/topic-list-item";
import TEMPLATE from "./mobile-category-topic.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend({
  tagName: "tr",
  classNameBindings: [":category-topic-link", "topic.archived", "topic.visited"],
  click: showEntrance
}));